import { useState } from "react";

import { toolbarActions  } from '../../services/EnumsService';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import ToolbarComponent from '../toolbar/ToolbarComponent';
import TaskResourceModal from './TaskResourceModal'

export default function TaskResourceComponent({taskResource}) {
    const [showTaskResourceModal, setShowTaskResourceModal] = useState(false)

    const editTaskResourceCloseAction = (()=>{
        setShowTaskResourceModal(false)
    })
    const editTaskResourceAction = (()=>{
        setShowTaskResourceModal(true)
    })
    const editTaskResourceModal = (<TaskResourceModal taskResourceId={taskResource.id} closeAction={editTaskResourceCloseAction}></TaskResourceModal>)

    return (
        <div>
            {showTaskResourceModal && editTaskResourceModal}
            <div key={taskResource.id} className="flex flex-row">
                
                <ToolbarComponent className='ml-2 mt-1'> 
                    <ToolbarOptionComponent title={'Editar'} size={20} icon={toolbarActions.Edit} clickAction={editTaskResourceAction}/>
                </ToolbarComponent>
                <a href={taskResource.link} rel="noopener" target="_blank">{taskResource.name}</a>
            </div>
        </div>
    )
}